import React, { Component } from "react";
import Language from "./Language/Language";
import { Paper, Menu, MenuItem, IconButton, Button } from "@material-ui/core";
import { inject, observer } from "mobx-react";

const style = {
  container: {
    display: "inline-block"
  }
}

@inject('languageStore')
@observer
export default class LanguageMenu extends Component {
  state = {
    open: false
  }

  constructor(props) {
    super(props);

    this.state.active = props.activeLanguage;
  }

  handleClick(lang) {
    if (this.props.onClick) {
      this.props.onClick(lang);
    } else {
      this.props.languageStore.setLanguage.bind(this.props.languageStore)(lang);
    }

    this.setState({open: false, active: lang});
  }

  render() {
    return (
      <div style={style.container}>
        <Button
          style={{display: "inline-block"}}
          aria-haspopup="true"
          onClick={(event) => this.setState({open: !this.state.open, anchorEl: event.currentTarget})}
        ><Language country={this.state.active}/></Button>

        <Menu
          anchorEl={this.state.anchorEl}
          open={this.state.open}>
          {
            this.props.languageStore.languages.map((lang) => {
              return (
                <MenuItem onClick={() => this.handleClick(lang)}>
                  <Language
                    country={lang}/>
                </MenuItem>
              );
            })
          }
        </Menu>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LanguageMenu/LanguageMenu.jsx